// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__13Tww","content":"styles_content__adNBM","selectAll":"styles_selectAll__1aZiu"};